import { css, CSSResultGroup } from 'lit';
import { environment } from '../../../environments/environment';

/** -------------------------------------------------------------------------
 * Responsive utility sheet

/** Design‑token breakpoints (mobile‑first) */
export const BREAKPOINTS = {
  mobileM: 375,
  tabletL: 1024,
  desktopXS: 1250,
  desktopS: 1366,
  desktopM: 1440,
  desktopXL: 1920
} as const;
/* ---------------------------------------------------------------------- */
export const responsiveSheet = new CSSStyleSheet();
const tabBorderSvgUrl = `${environment.assetsUrl}/images/tab-border.svg`;

responsiveSheet.replaceSync(`
  @media (min-width: ${BREAKPOINTS.mobileM}px) {
    nav.mega-menu-principal-container {
    }
  }

  @media (min-width: ${BREAKPOINTS.tabletL}px) {
    nav.mega-menu-principal-container {
    }
  }
  @media (min-width: ${BREAKPOINTS.desktopXS}px) {
    nav.mega-menu-principal-container {
      border-bottom: 4px solid var(--bc-brand-primary-00);
      & ul.core-options-container {
        display: flex;
        align-items: end;
        width: 40%;
        height: 100%;
        gap: 0.5rem;
        & .core-option {
          width: 164px;
          height: 44px;
          flex-grow: 1;
          cursor: pointer;
          border-radius: 16px 16px 0px 0px;
          box-sizing: border-box;
          padding: 4px;
          & .core-option-logo {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border-radius: 6px;
            padding: 14px;
          }
          &:hover {
            & .core-option-logo {
              background-color: var(--bc-brand-secondary-hover-00);
              
            }
          }
          &:active {
            & .core-option-logo {
              background-color: var(--bc-brand-secondary-press-00);
            }
          }
        }
        & li.core-option.selected {
          background-color: var(--bc-brand-primary-00);
          color: var(--bc-bg-primary-01);
          position: relative; 
          & img {
            filter: brightness(0) invert(1);
          }
          &:hover {
            & .core-option-logo {
              background-color: #595A5C;
              border-radius: 12px;
            }
          }
        }
        & li.core-option.selected::before,
        & li.core-option.selected::after {
          content: '';
          position: absolute;
          bottom: 0;
          height: 8px;
          width: 8px;
          background: url(${tabBorderSvgUrl}) no-repeat center bottom;
          background-size: contain;
          z-index: 2;
          pointer-events: none;
        }

        & li.core-option.selected::before {
          left: -8px;
          transform: scaleX(-1);
        }

        & li.core-option.selected::after {
          right: -8px;
        }
      }
      & ul.right-actions {
        #mobile-nav {
          display: none;
        }
        & li {
          padding: 4px 8px;
          border-radius: 6px;
          cursor: pointer;
          &:hover {
            background-color: var(--bc-brand-secondary-hover-00);
          }
          &:active {
            background-color: var(--bc-brand-secondary-press-00);
          }
          & span {
            display: block;
          }
        }
      }
    }
    nav.nav-container--active {
      position: fixed;
      top: 0;
      z-index: 1000;
    }
    section.submenu-container {
      background-color: var(--bc-bg-secondary-off);
      backdrop-filter: blur(4px);
      & section.submenu-container-left {
        width: 30%;
        height: 90%;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 0.3rem;
        border-radius: 1rem;
        background-color: var(--bc-bg-primary-01);
        transition: border-radius 0.3s ease;
      }
      & section.submenu-container-right {
        width: 0%;
        height: 90%;
        box-sizing: border-box;
        margin-top: 0.3rem;
        background-color: var(--bc-bg-primary-01);
        border-left: 4px solid var(--bc-brand-primary-00);
        border-radius: 0 1rem 1rem 0;
        opacity: 0;
        visibility: hidden;
        transition: width 0.3s ease, opacity 0.8s ease;
        overflow: auto;
        & h2.title {
          width: fit-content;
          padding: 0.5rem 0 0.5rem;
          margin-left: 0.5rem;
          border-bottom: 4px solid var(--color, var(--bc-brand-primary-00));
        }
        & .exit {
          height: 100%;
          box-sizing: border-box;
          font-weight: bold;
          border-radius: 0.5rem;
          padding: 0.3rem 0.5rem;
          cursor: pointer;
          &:hover {
            background-color: var(--bc-brand-secondary-hover-00);
          }
          &:active {
            background-color: var(--bc-brand-secondary-press-00);
          }
        }
        & div.category-options-container {
          display: block;
          column-width: 258px;
          column-gap: 2rem;
          padding-right: 0.5rem;
          overflow-y: auto;
          & .category-option {
            break-inside: avoid;
            -webkit-column-break-inside: avoid;
            width: 100%;
            margin: 0 0 1rem;
            & .category-option__title {
              margin: 0.5rem 0 0.5rem 0.5rem;
              font-family: 'CIB Sans Bold';
            }
            & .category-option__item {
              padding: 0.5rem 0 0.5rem 0.5rem;
              margin: 0;
              border-radius: 0.5rem;
              cursor: pointer;

              &:hover {
                background-color: var(--bc-brand-secondary-hover-00);
              }
              &:active {
                background-color: var(--bc-brand-secondary-press-00);
              }
            }
          }
        }
        .more-info {
          width: fit-content;
          padding: 0.5rem;
          border-radius: 0.5rem;
          font-weight: bold;
          cursor: pointer;
          &:hover {
            background-color: var(--bc-brand-secondary-hover-00);
          }
          &:active {
            background-color: var(--bc-brand-secondary-press-00);
          }
        }
      }
      & section.submenu-container-right--active {
        width: 70%;
        opacity: 1;
        visibility: visible;
      }
      & ul.submenu-option-container {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      & section.submenu-container-left--smashed {
        border-radius: 1rem 0px 0px 1rem;
        & .submenu-option--active {
          background-color: var(--bc-brand-primary-00);
          color: var(--bc-bg-primary-00);
        }
      }
      .selected-option {
        a {
          padding: 0.5rem;
          border-radius: 0.5rem;
          min-height: 48px;
          max-height: 48px;
          &:hover {
            background-color: var(--bc-brand-secondary-hover-00);
          }
          & img.title-option {
            object-fit: contain;
            transition: width 0.3s ease;
          }
        }
      }
      .selected-option--non-pressable {
        a {
          cursor: default;
          &:hover {
            background-color: initial;
            color: initial;
          }
        }
      }
      .submenu-option {
        text-align: left !important;
        padding: 0.5rem;
        cursor: pointer;
        border-radius: 0.5rem;
        transition: background-color 0.3s ease;
        font-family: 'CIB Sans Light';
        font-size: 18px;
        margin: 0;
        &.selected {
          background-color: var(--bc-brand-primary-00);
          color: var(--bc-bg-primary-01);
          font-family: 'CIB Sans Bold';
          &:hover {
            background-color: var(--bc-brand-primary-00);
            color: var(--bc-bg-primary-01);
          }
        }
        &:hover {
          background-color: var(--bc-brand-secondary-hover-00);
          color: var(--bc-brand-primary-00);
        }
        &:active {
          background-color: var(--bc-brand-secondary-press-00);
        }
      }
    }
  }
`);

/* ===================================================================== */
/* Helper for components to import the correct sheet array  -------------*/
export const responsiveStyles = [responsiveSheet];
